module.exports = __webpack_public_path__ + "img/testimonials-2.b6d17018.jpg";